
/* injects from baggage-loader */

'use strict';

export default class JobController {
  constructor($log) {
    'ngInject';

    this.$log = $log;
  }

  $onInit() {
    this.protectDownloadsWith = this.main.config.config.protectDownloadsWith;
    this.hasFileArtifact = (this.job.report.artifacts || []).find(item => item.dataType === 'file');
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/jobs/job.controller.js